/* FLM — in-app notification sound. A short two-tone chime synthesized via the
   Web Audio API: no asset to ship, works offline, ~0 bytes of bundle. Browsers
   block audio until a user gesture, so unlockAudio() is wired to the first tap.
   Respects a mute preference (localStorage 'flm-sound' === '0' → silent). */

let ctx = null;

function ensureCtx() {
  if (ctx) return ctx;
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    ctx = AC ? new AC() : null;
  } catch {
    ctx = null; // no Web Audio (old webview) — silent, never throws
  }
  return ctx;
}

/* Unlock on a user gesture so later programmatic plays are allowed by the
   browser autoplay policy. Safe to call repeatedly. */
export function unlockAudio() {
  const c = ensureCtx();
  if (c && c.state === 'suspended') c.resume().catch(() => {});
}

export function soundEnabled() {
  return localStorage.getItem('flm-sound') !== '0';
}
export function setSoundEnabled(on) {
  localStorage.setItem('flm-sound', on ? '1' : '0');
}

let lastPing = 0;
/* Soft incoming-message chime (A5 → D6). Debounced so a burst of messages
   doesn't machine-gun the speaker. */
export function playPing() {
  if (!soundEnabled()) return;
  const c = ensureCtx();
  if (!c) return;
  const now = Date.now();
  if (now - lastPing < 1200) return;
  lastPing = now;
  if (c.state === 'suspended') c.resume().catch(() => {});
  try {
    const t0 = c.currentTime;
    for (const [freq, off] of [[880, 0], [1174.66, 0.12]]) {
      const osc = c.createOscillator();
      const gain = c.createGain();
      osc.type = 'sine';
      osc.frequency.value = freq;
      const start = t0 + off;
      gain.gain.setValueAtTime(0, start);
      gain.gain.linearRampToValueAtTime(0.16, start + 0.015); // gentle attack
      gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.22); // soft tail
      osc.connect(gain).connect(c.destination);
      osc.start(start);
      osc.stop(start + 0.24);
    }
  } catch {
    /* a play failure must never bubble into the UI */
  }
}
